import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const CompanyContext = createContext(null);

// "all" means Grupo ALCON consolidado
export const CompanyProvider = ({ children }) => {
  const { user } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [selected, setSelected] = useState(
    localStorage.getItem("rh_selected_company") || "all"
  );
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!user || user === false) return;
    setLoading(true);
    try {
      const { data } = await api.get("/companies");
      setCompanies(data);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { load(); }, [load]);

  const select = (id) => {
    setSelected(id);
    localStorage.setItem("rh_selected_company", id);
  };

  const selectedCompany = companies.find((c) => c.id === selected) || null;
  const companyParam = selected === "all" ? null : selected;

  return (
    <CompanyContext.Provider
      value={{ companies, selected, select, selectedCompany, companyParam, loading, reload: load }}
    >
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => useContext(CompanyContext);
